/*  MUI  */
import { Typography } from '@mui/material';
import { CellContext, Row } from '@tanstack/react-table';

/* Shared */
import { ClassificationStatus } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ColumnFilter } from '../Table/types';

/**
 * Configuration object for classification data filtering control.
 */
export const classificationCellFilter: ColumnFilter<unknown> = {
    control: 'Checkbox',
    defaultOptions: [
        {
            options: [
                ClassificationStatus.Classified,
                ClassificationStatus.Unclassified
            ]
        }
    ]
};

/**
 * Filter function for classification data cells in a table
 * @param {Row<TData>} row - The row data containing the information
 * @param {string} columnId - The ID of the column being filtered
 * @param {string} filterValue - The filter value to match against
 * @returns {boolean} True if the row should be included in filtered results, false otherwise
 */
export function classificationCellFilterFn<TData>(
    row: Row<TData>,
    columnId: string,
    filterValue: string[]
): boolean {
    if (!filterValue || !filterValue?.length) return true;

    // filterValue can be [ClassificationStatus.Classified], [ClassificationStatus.Unlassified],
    // or [ClassificationStatus.Classified, ClassificationStatus.Unlassified ],
    // in other words, === ['true', 'false'], or ['true'], or['false']

    const rowClassificationValue = row.getValue(columnId);

    return (
        (rowClassificationValue === true &&
            filterValue.includes(ClassificationStatus.Classified)) ||
        (rowClassificationValue === false &&
            filterValue.includes(ClassificationStatus.Unclassified))
    );
}

export const ClassificationCell = <TData,>({
    row
}: CellContext<TData, unknown>): JSX.Element => {
    const { t } = useTranslation();
    return (
        <Typography>
            {/* @ts-expect-error TData */}
            {row.original?.classified
                ? t('Common.classified')
                : t('Common.unclassified')}
        </Typography>
    );
};
